import { useState } from 'react'

function DeleteConfirm({ log, onConfirm, onCancel }) {
  const [animating, setAnimating] = useState(false)
  if (!log) return null

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '20px' }} onClick={onCancel}>
      <div className="animate-slide-up" style={{
        background: 'rgba(255, 255, 255, 0.06)',
        backdropFilter: 'saturate(180%) blur(50px)',
        WebkitBackdropFilter: 'saturate(180%) blur(50px)',
        border: '0.5px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 0.5px 0 rgba(255, 255, 255, 0.15), inset 0 -0.5px 0 rgba(0, 0, 0, 0.05)',
        borderRadius: 'var(--radius-2xl)',
        padding: '32px 24px 24px',
        maxWidth: '340px',
        width: '100%',
      }} onClick={e => e.stopPropagation()}>
        <p style={{ fontSize: 'var(--text-lg)', lineHeight: 'var(--leading-relaxed)', textAlign: 'left', marginBottom: '24px', color: 'var(--color-text-primary)' }}>
          This log will be permanently deleted and cannot be restored.
        </p>
        <button onClick={() => { setAnimating(true); setTimeout(() => { setAnimating(false); onConfirm(log.id) }, 180) }}
          style={{
            width: '100%',
            padding: '16px',
            background: 'rgba(255, 255, 255, 0.05)',
            border: '0.5px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '100px',
            color: 'var(--color-danger)',
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--weight-semibold)',
            cursor: 'pointer',
            transform: animating ? 'scale(0.95)' : 'scale(1)',
            transition: 'transform 0.18s var(--ease-spring)',
            fontFamily: 'var(--font-system)',
          }}>
          Delete
        </button>
      </div>
    </div>
  )
}

export default DeleteConfirm